import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-d67a079a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "icc-login"
};
var _hoisted_2 = {
  class: "login-content"
};
var _hoisted_3 = {
  class: "contest-area"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "slogon-box"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: "https://img.pipacoding.com/competition/materials/2025/icc/0226/icc-slogon-2.png",
    alt: ""
  })], -1);
});
var _hoisted_5 = {
  class: "login-box"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "contest-bot"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "txt-center"
  }, [/*#__PURE__*/_createTextVNode(" 大赛官方地址： "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.icc-edu.org.cn/",
    target: "_blank"
  }, " https://www.icc-edu.org.cn/ ")]), /*#__PURE__*/_createElementVNode("div", {
    class: "txt-center"
  }, "版权所有 全球发明大会中国区")], -1);
});
import ContestLogin from '../../common/components/ContestLogin/index.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(ContestLogin, {
        theme: "icc",
        carNoInfo: {
          placeholder: '请输入选手身份证号后6位',
          ruleMessage: '请输入选手身份证号后6位'
        },
        "contest-type": "icc",
        "contest-year": "2025"
      })])]), _hoisted_6])]);
    };
  }
});